import React, { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import * as scroll from 'react-scroll'
import {Link} from 'react-dom'

function Bar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.style.overflow = isOpen ? 'auto' : 'hidden';
  };
  

  return (
    <div>
      <div className='text-white cursor-pointer my-4' onClick={toggleMenu}>
        <MenuIcon sx={{ fontSize: 40 }} />
      </div>
      {isOpen && (
        <div className='fixed top-0 left-0 z-50 w-full h-full bg-[#333333] flex items-center justify-center'>
          <ul className='text-white text-center'>
    <li className='hover:text-red-600 mb-32 font-primary mt-10 font-bold text-3xl'><a href=""><CloseIcon sx={{ fontSize: 70 }}/></a></li>
    <li className='hover:text-[#D5FF3C] animate-animation_menu m-10 font-primary font-bold text-6xl'><a href="">    
      <scroll.Link
      to='Skills'
      smooth={true}
      offset={-400}
      >Skills</scroll.Link> 
      </a></li>
    <li className='hover:text-[#D5FF3C] animate-animation_menu m-10 font-primary font-bold text-6xl'><a href="">
    <scroll.Link
      to='portfolio'
      smooth={true}
      offset={-300}
      >portfolio</scroll.Link>
      </a></li>
    <li className='hover:text-[#D5FF3C] animate-animation_menu m-10 font-primary font-bold text-6xl'><a href="">
    <scroll.Link
      to='Contact'
      smooth={true}
      duration={1500}
      offset={-100}
      >contact us</scroll.Link>
      </a></li>
  </ul>  
        </div>
      )}
    </div>
  );
}

export default Bar;